/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close dialog" |
*
* @param {Insert_Speaker_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_close_label = /** @type {((inputs?: Insert_Speaker_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la boîte de dialogue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialog schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi finestra di dialogo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть диалог")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar diálogo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭对话框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダイアログを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar caixa de diálogo")
	return /** @type {LocalizedString} */ ("Close dialog")
});